// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89638d89","552":"183adffc"}[chunkId] + ".chunk.js";
};